import React from 'react';

export const CapacitorContext = React.createContext();
